import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import App from './App';
import "react-datepicker/dist/react-datepicker.css";
import './assets/css/style.css';
import {createStore, applyMiddleware, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';
import allReducers from "./reducers";
import {Provider} from "react-redux";
import { composeWithDevTools } from 'redux-devtools-extension';

const middlewares = [thunkMiddleware];
const middlewareEnhancer = /*composeWithDevTools(*/
    applyMiddleware(...middlewares)
/*)*/;

const enhancers = [middlewareEnhancer];
const composedEnhancers = compose(...enhancers);

const store = createStore(
    allReducers,
    composedEnhancers
);

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <Router>
                <App/>
            </Router>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);